module.exports = __webpack_public_path__ + "static/media/sms.ecfd1310.svg";